import { createContext, SetStateAction, Dispatch } from 'react';

import { FormInstance } from 'antd';


import { CreditCardsInsured } from '../../../../../../../../../../../shared/interfaces';
import { AdditionalDataSectionForm, ClientDataSectionForm, PaymentMethodSectionForm } from './StepFiveFormProvider';
import { TransferRightsFormData } from '../../../../../../../../../../../shared/interfaces/services/transfer-rights-service';

interface StepFiveFormContextProps {
  additionalDataFormValues:           AdditionalDataSectionForm | undefined;    
  setAdditionalDataFormValues:        Dispatch<SetStateAction<AdditionalDataSectionForm | undefined>>;

  additionalDataSectionForm:          FormInstance<AdditionalDataSectionForm>;

  clientDataFormValues:               ClientDataSectionForm | undefined;
  setClientDataFormValues:            Dispatch<SetStateAction<ClientDataSectionForm | undefined>>;

  clientDataSectionForm:              FormInstance<ClientDataSectionForm>;

  errorCreditCardMessage:             string;
  setErrorCreditCardMessage:          Dispatch<SetStateAction<string>>;

  listCreditCardInsured:              CreditCardsInsured | undefined;
  setListCreditCardInsured:           Dispatch<SetStateAction<CreditCardsInsured | undefined>>;

  methodSelectedFromStepThree:        any;
  setMethodSelectedFromStepThree:     Dispatch<SetStateAction<any>>;

  paymentMethodFormValues:            PaymentMethodSectionForm | undefined;
  setPaymentMethodFormValues:         Dispatch< SetStateAction<PaymentMethodSectionForm | undefined>>;

  paymentMethodSectionForm:           FormInstance<PaymentMethodSectionForm>;

  propertyDataForm:                   FormInstance<any>;

  validitySectionForm:                FormInstance<{ validityDate: any }>;

  setTransferRightsList:              Dispatch<SetStateAction<TransferRightsFormData[]>>;
  transferRightsList:                 TransferRightsFormData[];
}

export const StepFiveFormContext = createContext(
  {} as StepFiveFormContextProps
);
